import ToolTip from 'Components/ToolTip';
import apiGlobal from 'global/api.global';
import { RootState } from 'index';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { Row, Col, Label } from 'reactstrap'
import STSAdjustmentPopup from './STSAdjustmentPopup';

const PendingSTSAdjustment = ({ active }: any) => {
    /** State variables */
    const { VesselID } = useSelector((state: RootState) => state.Reporting);
    const [tableDetails, setTableDetails] = useState<Array<any>>([]);
    const [count, setCount] = useState(0);
    const [adjustmentPopup, setAdjustmentPopup] = useState(false);
    const [eventState, setEventState] = useState<any>({});
    /** State variables end */

    /** Load STS operations pending for approval of the selected vessel */
    const loadData = async () => {
        await apiGlobal.get(`sts_operation_detail/get_sts_operation_details_by_vessel/?vessel_id=${VesselID}`).then(response => {
            setTableDetails(response.data.filter((item: any) => item.user_approved === false));
            setCount(count => count + 1);
        }).catch(err => {
            setTableDetails([])
        })
    };

    /** useEffect start */
    useEffect(() => {
        loadData();
    }, [VesselID, active])
    /** useEffect end */

    /** Open-close modal */
    function tog_backdrop() {
        setAdjustmentPopup(!adjustmentPopup);
        removeBodyCss();
    }

    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }

    return (
        <Row className='mb-3'>
            <Col lg={12}>
                <div className="table-responsive">
                    <table className="table mb-0" key={count}>
                        <thead className="table-light">
                            <tr>
                                <th>Sr. No.</th>
                                <th>Duration</th>
                                <th>STS Operation</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tableDetails?.map((sts: any, index: any) => {
                                return (
                                    <tr>
                                        <td>{index + 1}</td>
                                        <td>
                                            {sts?.sts_end_time === null ?
                                                <Label>Currently in progress</Label> :
                                                <>
                                                    {sts?.sts_start_time?.toString().substring(0, 10)}&nbsp;
                                                    {sts?.sts_start_time?.toString().substring(12, 16)}&nbsp;&nbsp;to&nbsp;&nbsp;
                                                    {sts?.sts_end_time?.toString().substring(0, 10)}&nbsp;
                                                    {sts?.sts_end_time?.toString().substring(12, 16)}
                                                </>
                                            }
                                        </td>
                                        <td>{sts?.sts_loading === true ? <Label>STS Loading</Label> :
                                            sts?.sts_discharging === true ? <Label>STS Discharging</Label> :
                                                <Label>Port Discharging</Label>}
                                        </td>
                                        <td className='nopadtop align-middle'>
                                            <i className='mdi mdi-checkbox-multiple-marked-outline icon_s23' id={`sts_validate${index}`}
                                                onClick={() => {
                                                    setAdjustmentPopup(true);
                                                    setEventState(sts);
                                                }} />
                                        </td>
                                        <ToolTip target={`sts_validate${index}`} message='Validate STS Adjustment' />
                                    </tr>
                                )
                            })}
                            {adjustmentPopup === true &&
                                <STSAdjustmentPopup
                                    state={adjustmentPopup}
                                    setState={setAdjustmentPopup}
                                    toggle={tog_backdrop}
                                    event={eventState}
                                    target={`popup${eventState?.id}`}
                                />
                            }
                        </tbody>
                    </table>
                </div>
            </Col>
        </Row>
    )
}

export default PendingSTSAdjustment